import { WIDGET_COMPONENT_NAMES } from '../shared/features/widgets/widgets.constants';

export const componentNames = WIDGET_COMPONENT_NAMES;
